import { _ as n } from "./index.es284.js";
var o = n, e = o ? o.prototype : void 0, l = e ? e.valueOf : void 0;
function a(r) {
  return l ? Object(l.call(r)) : {};
}
var t = a;
export {
  t as _
};
//# sourceMappingURL=index.es395.js.map
